import { IconFullWidthTextComponent } from '@varo/graphql-schema-types';
import { IconAvatarProps } from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import { iconKeyForStyleDictionary } from 'shared/components/vxl/icon/Icon/Icon.helpers';
import { ListItemProps } from 'shared/components/vxl/ListItem/ListItem';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';

const iconFullWidthTextComponent = (
  component: IconFullWidthTextComponent,
): VXLNode => {
  return {
    id: component.id,
    name: VXLComponentId.LIST_ITEM,
    props: {
      primaryCopy: component.title.copy,
      secondaryCopy: component.subtitle?.copy,
      showsChevron: false,
      leadingAccessory: {
        id: 'leading-accessory',
        name: VXLComponentId.ICON_AVATAR,
        props: {
          iconKey: iconKeyForStyleDictionary(component.icon) ?? undefined,
          variant: 'MD',
        } satisfies IconAvatarProps,
      },
    } satisfies ListItemProps,
  };
};

export default iconFullWidthTextComponent;
